import React from 'react'

import { Popup, PopupProps } from 'semantic-ui-react'
import { Timing } from '@cbgms/base/utils/timing'

/**
 * @deprecated use MUI Tooltip  instead
 */
export const Tooltip: React.FC<PopupProps> = props => {
  return <Popup mouseEnterDelay={Timing.mouseOver} openOnTriggerClick={false} closeOnTriggerClick {...props} />
}

Tooltip.defaultProps = {
  inverted: true
}

Tooltip.displayName = 'Tooltip'
